import Cookies from 'js-cookie';

const MUNCHKIN_ID = '964-WFU-818';

const INTEGRATIONS = {
    GOOGLE_ANALYTICS: {
        getSrc: () => 'https://www.google-analytics.com/analytics.js',
        getOnLoad: () => () => {
            window.ga.l = +new Date();
            window.ga('create', 'UA-3221223-1', 'auto', {});
        },
    },
    GOOGLE_TAG_MANAGER: {
        getSrc: () => 'https://www.googletagmanager.com/gtm.js?id=GTM-W4PPZ6',
        getOnLoad: () => () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            });
        },
    },
    MARKETO: {
        getSrc: () => 'https://munchkin.marketo.net/munchkin.js',
        getOnLoad: () => () => {
            if (window.Munchkin) {
                window.Munchkin.init(MUNCHKIN_ID);
                if (!Cookies.get('_mkto_trk')) {
                    window.Munchkin.createTrackingCookie();
                }
            }
        },
    },
};

export const getIntegrationScript = (name: string): HTMLElement | null =>
    document.getElementById(`marketing-integration-${name}`);

export const loadMarketingIntegrations = () => {
    Object.entries(INTEGRATIONS).forEach(([name, integration]) => {
        if (getIntegrationScript(name)) {
            return;
        }
        const script = document.createElement('script');
        script.src = integration.getSrc();
        script.onload = integration.getOnLoad();
        script.id = `marketing-integration-${name}`;
        document.body.appendChild(script);
    });
};

export const removeMarketingIntegrations = () => {
    Object.keys(INTEGRATIONS).forEach((name) => {
        const script = getIntegrationScript(name);
        if (script) {
            document.body.removeChild(script);
        }
    });
};
